var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxnInTransitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#A4D7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.525 20.525L23.025 25.025C22.875 25.175 22.725 25.25 22.5 25.25C22.275 25.25 22.125 25.175 21.975 25.025C21.675 24.725 21.675 24.275 21.975 23.975L25.2 20.75H15C14.55 20.75 14.25 20.45 14.25 20C14.25 19.55 14.55 19.25 15 19.25H25.2L21.975 16.025C21.675 15.725 21.675 15.275 21.975 14.975C22.275 14.675 22.725 14.675 23.025 14.975L27.525 19.475C27.6 19.55 27.675 19.625 27.675 19.7C27.75 19.85 27.75 20.075 27.675 20.3C27.675 20.375 27.6 20.45 27.525 20.525Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25084_31185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 14,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.525 20.525L23.025 25.025C22.875 25.175 22.725 25.25 22.5 25.25C22.275 25.25 22.125 25.175 21.975 25.025C21.675 24.725 21.675 24.275 21.975 23.975L25.2 20.75H15C14.55 20.75 14.25 20.45 14.25 20C14.25 19.55 14.55 19.25 15 19.25H25.2L21.975 16.025C21.675 15.725 21.675 15.275 21.975 14.975C22.275 14.675 22.725 14.675 23.025 14.975L27.525 19.475C27.6 19.55 27.675 19.625 27.675 19.7C27.75 19.85 27.75 20.075 27.675 20.3C27.675 20.375 27.6 20.45 27.525 20.525Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25084_31185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11H30V29H12V11Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxnInTransitIcon);
export default __webpack_public_path__ + "static/media/TxnInTransitIcon.5db8be4b541dda46eb9a36ced2fc56ed.svg";
export { ForwardRef as ReactComponent };